import { Button, useRecordContext, useResourceContext, useTranslate } from 'react-admin';
import { Edit as EditIcon } from '@mui/icons-material';
import useDialogContext from 'components/DialogContainer/useDialogContext';

interface EditSubItemProps {
  label?: string;
  resource?: string;
  childre?: React.ReactElement;
}
const EditSubItem = (props: EditSubItemProps) => {
  const resource = useResourceContext(props);
  const record = useRecordContext(props);
  const t = useTranslate();
  const { openEditDialog, editForm } = useDialogContext();

  if (!editForm || !record) return null;

  // No try/catch: `useTranslate()` cannot throw on a missing key. The provider is built with
  // polyglot's `allowMissing`, so node-polyglot returns the key itself instead of raising
  // (node-polyglot 2.6.0 `Polyglot.prototype.t` → `onMissingKey`), and react-admin falls back to
  // the identity function when no i18nProvider is mounted. Either way `t` yields a string.
  const label =
    props.label ||
    t('custom.actions.edit', {
      name: t(`resources.${resource}.name`, { smart_count: 1 }).replace(/^\w/, (c) => c.toLowerCase()),
      Name: t(`resources.${resource}.name`, { smart_count: 1 }),
    });

  return (
    <Button label={label} onClick={() => openEditDialog(record)}>
      <EditIcon />
    </Button>
  );
};

export default EditSubItem;
